import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	quotedTitle: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	workedon: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	viewed: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	assigned: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	starred: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	boards: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	workSuggestions: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	experimentSettingsChangeFailFeedback: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	experimentPreferenceChangeSuccessMessage: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	projects: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	dashboards: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	title: {
		defaultMessage: 'Your work',
		id: 'home.title',
		description: 'Page title for the "Jira Home" / "Your work" page.',
	},
	quotedTitle: {
		defaultMessage: '‘Your work’',
		id: 'home.quoted-title',
		description: 'Page title for the Jira Home page, but as quoted.',
	},
	workedon: {
		defaultMessage: 'Worked on',
		id: 'home.workedon',
		description:
			'The label for the Jira Home tab which contains the list of issues the user recently worked on.',
	},
	viewed: {
		defaultMessage: 'Viewed',
		id: 'home.viewed',
		description:
			'The label for the Jira Home tab which contains the list of issues the user recently viewed.',
	},
	assigned: {
		defaultMessage: 'Assigned to me',
		id: 'home.assigned',
		description:
			'The label for the Jira Home tab which contains the list of issues assigned to the user.',
	},
	starred: {
		defaultMessage: 'Starred',
		id: 'home.starred',
		description:
			'The label for the Jira Home tab which contains the list of issues starred by the user.',
	},
	boards: {
		defaultMessage: 'Boards',
		id: 'home.boards',
		description: "The label for the Jira Home tab which contains the list of the user's boards.",
	},
	workSuggestions: {
		defaultMessage: 'Work suggestions',
		id: 'home.work-suggestions',
		description:
			"The label for the Jira Home tab which contains the list of the user's work suggestions (for software team users).",
	},
	experimentSettingsChangeFailFeedback: {
		defaultMessage: 'Something went wrong saving your preference',
		id: 'home.experiment-settings-change-fail-feedback',
		description:
			'The message shown to the user to alert them that Jira failed to save their preferences regarding admission to the Jira Home experiment.',
	},

	experimentPreferenceChangeSuccessMessage: {
		defaultMessage: '{destinationPage} is now your default homepage.',
		id: 'home.experiment-preference-change-success-message',
		description:
			'A feedback message shown in the Flag that tells the user they have successfully opted in or opted out of Jira Home.',
	},
	projects: {
		defaultMessage: 'Projects',
		id: 'home.projects',
		description: "The name of the page where the user's projects can be found",
	},
	dashboards: {
		defaultMessage: 'Dashboards',
		id: 'home.dashboards',
		description: "The name of the page where the user's work summary can be found",
	},
});
export default messages;
